"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInteger = void 0;
/**
 * @summary Determines if a string contains an integral number.
 *
 * Checks if a string contains an integer. Float values are rejected. Whitespace at the beginning and end
 * are ignored.
 *
 * @param {string | undefined} text
 * @returns {boolean}
 *
 * @example
 * if (isInteger('5')) {
 *   // ...
 * }
 */
function isInteger(text) {
    return !!text?.trim() && !isNaN(+text) && Number.isInteger(+text);
}
exports.isInteger = isInteger;
